import { updateHomePageCategory } from '../../..../../../actions/siteadmin/updateHomePageCategory'
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    let havingDataWithoutImage = !values?.logo || !values?.banner;
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    if (havingDataWithoutImage) {
        showToaster({ messageId: 'pleaseUpload', toasterType: 'error' });
        return;
    }
    await dispatch(updateHomePageCategory({ categoryList: values }))
}

export default submit;